module.exports = __webpack_public_path__ + "img/facebook-bg.cfd490f2.png";